import { render, staticRenderFns } from "./NavigationNotificationCountBadge.vue?vue&type=template&id=6b3d3029&scoped=true"
import script from "./NavigationNotificationCountBadge.vue?vue&type=script&lang=js"
export * from "./NavigationNotificationCountBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3d3029",
  null
  
)

export default component.exports